module.exports = __webpack_public_path__ + "static/img/ticket1_bg.ddc4dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/ticket1_bg.png
// module id = 8jAE
// module chunks = 1